import {Brand, Occasion} from "../../../../../server/src/base/entities/occasion/Occasion";
import {Occasions} from "../../../../../server/src/base/entities/occasion/Occasions";

export abstract class IOccasionService {
    public abstract Occasions():Promise<Occasions>;
    public abstract Refresh():Promise<void>;
}

export class FakeOccasionService implements IOccasionService{

    Occasions(): Promise<Occasions> {
        let occasions:Occasions = new Occasions();
        let nbBrands:number = Object.keys(Brand).length / 2;

        let occasionList:Array<Occasion> = [];
        for(let i = 0 ; i < nbBrands; ++i){
            let numberOfCars:number = Math.floor(Math.random() * 15) + 3;
            occasionList = occasionList.concat(this.GenerateOccasions(i, numberOfCars));
        }
        occasions.SetOccasions(occasionList);
        return Promise.resolve(occasions);
    }

    public Refresh(): Promise<void> {
        return Promise.resolve();
    }

    private GenerateOccasions(brand:Brand, number:number){
        let occasions:Array<Occasion> = [];
        for(let i = 0 ; i < number; ++i){
            occasions.push(this.GenerateOccasion(brand));
        }
        return occasions;
    }

    private GenerateOccasion(brand:Brand){
        let occasion:Occasion = new Occasion().AsFake();
        occasion.brand = brand;
        return occasion;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/occasions/IOccasionService.ts